<template>
  <div class="deviceMonitor-container">
    <div id="map-box"></div>
    <el-header class="watch-header">
      <el-row class="header-title">地灾监测平台</el-row>
    </el-header>
    <!-- 监测点信息表 -->
    <div class="windowBox" ref="windowBox" v-show="showBox">
      <div class="point-title">
        <span>监测点信息</span>
        <i class="el-icon-close cive" @click="closeWindowBox"></i>
      </div>
      <div class="point-content">
        <el-image style="width: 100%; height: 210px" :src="url"></el-image>
        <div class="text">
          <el-row style="font-size: 14px; color: #fff">{{ baseList.stationName }}</el-row>

          <el-row>
            <el-col :span="6">监测点编号:</el-col>
            <el-col :span="18">{{ baseList.pointNum }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="6">监测点类型:</el-col>
            <el-col :span="18">{{ baseList.type }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="7">监测点设备数:</el-col>
            <el-col :span="17">{{ baseList.deviceNum }}</el-col>
          </el-row>
          <el-row type="flex">
            <el-col style="width: 86px">巡检周期:</el-col>
            <el-col>{{ baseList.pollingPeriod }}</el-col>
          </el-row>
          <el-row type="flex">
            <el-col style="width: 120px">上次巡检时间:</el-col>
            <el-col>{{ baseList.lastPollingTime }}</el-col>
          </el-row>
          <el-row type="flex">
            <el-col style="width: 86px">地理位置:</el-col>
            <el-col>{{ baseList.address }}</el-col>
          </el-row>
          <el-row type="flex">
            <el-col style="width: 48px">经度:</el-col>
            <el-col>{{ baseList.longitude }}</el-col>
          </el-row>
          <el-row type="flex">
            <el-col style="width: 48px">纬度:</el-col>
            <el-col>{{ baseList.latitude }}</el-col>
          </el-row>
          <el-row type="flex">
            <el-col style="width: 48px">高程:</el-col>
            <el-col>{{ baseList.height }}</el-col>
          </el-row>
        </div>
        <div class="tag">
          <el-button type="primary" @click="toDetails">详情信息</el-button>
          <el-button type="primary" @click="showDialog">全景照片</el-button>
          <el-button type="primary" @click="showGISDialog">三维地图</el-button>
          <el-button type="primary" @click="topollingRecord">巡检记录</el-button>
        </div>
      </div>
    </div>

    <!-- 具体设备点信息窗体 -->
    <div class="pointInfoWindow" ref="pointInfoWindow" v-show="showInfoWindow">
      <i class="delta" />
      <!-- <div class="pointInfo-title">
        <div>设备信息</div>
        <i class="el-icon-close" @click="closePointWindow" />
      </div> -->
      <div class="pointInfo-content">
        <el-row type="flex">
          <el-col style="width: 86px">设备编号:</el-col>
          <el-col>{{ listObj.deviceNum }}</el-col>
        </el-row>
        <el-row type="flex">
          <el-col style="width: 86px">检测类型:</el-col>
          <el-col>{{ listObj.type }}</el-col>
        </el-row>
        <el-row type="flex">
          <el-col style="width: 86px">建设单位:</el-col>
          <el-col>{{ listObj.constructionUnit }}</el-col>
        </el-row>
        <el-row type="flex">
          <el-col style="width: 86px">维护单位:</el-col>
          <el-col>{{ listObj.maintenanceUnit }}</el-col>
        </el-row>
        <el-row type="flex">
          <el-col style="width: 86px">设备经度:</el-col>
          <el-col>{{ lng }}</el-col>
        </el-row>
        <el-row type="flex">
          <el-col style="width: 86px">设备纬度:</el-col>
          <el-col>{{ lat }}</el-col>
        </el-row>
      </div>
      <div class="pointInfo-footer">
        <el-button type="text" @click="showDialog">全景图</el-button>
      </div>
    </div>

    <!-- 高德地图点击车辆标注显示的盒子
    <div class="infoWindow" ref="vehicleInfowindow" v-show="vehicleId">
      <i class="delta"></i>
      <el-row
        class="orderTime"
        v-if="vehicleInfoWindowData.orderState && vehicleInfoWindowData.orderState != 1"
      >
        <el-col :span="8">工单历时</el-col>
        <el-col :span="16">{{ vehicleInfoWindowData.takeTime }}</el-col>
      </el-row>
      <el-row class="infoWindow-detail">
        <el-row class="vehicleStatus">
          <span class="powering" v-if="vehicleInfoWindowData.powerState == 1"
            >发电中</span
          >
          <span class="fueling" v-if="vehicleInfoWindowData.oilPumpingState == 1"
            >抽油中</span
          >
          <span class="no-receive" v-if="vehicleInfoWindowData.orderState == 1"
            >未接单</span
          >
          <span class="routing" v-if="vehicleInfoWindowData.orderState == 2">在途中</span>
          <span class="routing" v-if="vehicleInfoWindowData.orderState == 3">已接单</span>
        </el-row>
        <el-row class="carNumber">{{ vehicleInfoWindowData.plateNum }}</el-row>
        <el-row>{{ vehicleInfoWindowData.name }}</el-row>
        <el-row>{{ vehicleInfoWindowData.phone }}</el-row>
        <el-row>
          <span>剩余油量：</span>
          <span>{{
            vehicleInfoWindowData.version == 2 ? "-" : vehicleInfoWindowData.adFuel + "L"
          }}</span>
        </el-row>
        <el-row>
          <span>当前车速：</span>
          <span>{{ vehicleInfoWindowData.absVehicleSpeed }}KM/H</span>
        </el-row>
        <el-row v-if="vehicleInfoWindowData.powerState == 1">
          <el-row>
            <span>发电功率：</span>
            <span>{{ vehicleInfoWindowData.forwardPower }}W</span>
          </el-row>
          <el-row>
            <span>发电时长：</span>
            <span>{{ vehicleInfoWindowData.duration }}</span>
          </el-row>
          <el-row>
            <span>发电量：</span>
            <span>{{ vehicleInfoWindowData.capacity }}KW·H</span>
          </el-row>
        </el-row>
        <el-row v-if="bankRoute">
          <el-row>
            <span>预计行程：</span>
            <span>{{ drivingRoutel }}</span>
          </el-row>
          <el-row>
            <span>预计用时：</span>
            <span>{{ drivingTime }}</span>
          </el-row>
        </el-row>
      </el-row>
      <span
        class="checkDetail"
        @click="getVehicleDetail(vehicleInfoWindowData.vin)"
        v-if="hasPerm('maintain:monitor:vehicle:details:v3')"
      >
        查看详情
      </span>
    </div> -->

    <!-- 高德地图点击车辆标注显示的盒子 -->
    <el-row class="infoWindow" ref="vehicleInfowindow" v-show="vehicleId">
      <i class="delta"></i>
      <el-row
        class="orderTime"
        v-if="vehicleInfoWindowData.orderState && vehicleInfoWindowData.orderState != 1"
      >
        <el-col :span="8">工单历时</el-col>
        <el-col :span="16">{{ vehicleInfoWindowData.takeTime }}</el-col>
      </el-row>
      <el-row class="infoWindow-detail">
        <el-row class="vehicleStatus">
          <span class="powering" v-if="vehicleInfoWindowData.powerState == 1"
            >发电中</span
          >
          <span class="fueling" v-if="vehicleInfoWindowData.oilPumpingState == 1"
            >抽油中</span
          >
          <span class="no-receive" v-if="vehicleInfoWindowData.orderState == 1"
            >未接单</span
          >
          <span class="routing" v-if="vehicleInfoWindowData.orderState == 2">在途中</span>
          <span class="routing" v-if="vehicleInfoWindowData.orderState == 3">已接单</span>
        </el-row>
        <el-row class="carNumber">{{ vehicleInfoWindowData.plateNum }}</el-row>
        <el-row>{{ vehicleInfoWindowData.name }}</el-row>
        <el-row>{{ vehicleInfoWindowData.phone }}</el-row>
        <el-row>
          <span>剩余油量：</span>
          <span>{{
            vehicleInfoWindowData.version == 2 ? "-" : vehicleInfoWindowData.adFuel + "L"
          }}</span>
        </el-row>
        <el-row>
          <span>当前车速：</span>
          <span>{{ vehicleInfoWindowData.absVehicleSpeed }}KM/H</span>
        </el-row>
        <el-row v-if="vehicleInfoWindowData.powerState == 1">
          <el-row>
            <span>发电功率：</span>
            <span>{{ vehicleInfoWindowData.forwardPower }}W</span>
          </el-row>
          <el-row>
            <span>发电时长：</span>
            <span>{{ vehicleInfoWindowData.duration }}</span>
          </el-row>
          <el-row>
            <span>发电量：</span>
            <span>{{ vehicleInfoWindowData.capacity }}KW·H</span>
          </el-row>
        </el-row>
        <el-row v-if="bankRoute">
          <!-- <el-row v-if="(vehicleInfoWindowData.orderState == 2&&vehicleInfoWindowData.powerState != 1) || bankRoute"> -->
          <el-row>
            <span>预计行程：</span>
            <span>{{ drivingRoutel }}</span>
          </el-row>
          <el-row>
            <span>预计用时：</span>
            <span>{{ drivingTime }}</span>
          </el-row>
        </el-row>
      </el-row>
      <span
        class="checkDetail"
        @click="getVehicleDetail(vehicleInfoWindowData.vin)"
        v-if="hasPerm('maintain:monitor:vehicle:details:v3')"
      >
        查看详情
      </span>
    </el-row>

    <!-- 监测点详情模态框 -->
    <el-dialog class="details" :visible.sync="showDetails" :show-close="false">
      <!-- 自定义标题栏 -->
      <div slot="title" class="dialog-title">
        <span>监测点详情</span>
        <i class="el-icon-close" @click="showDetails = false"></i>
      </div>
      <div class="details-content">
        <div class="top">
          <el-row>
            <el-col :span="11">
              <span class="required">监测点编号</span>
              <span class="text">{{ detailsDataTop.pointNum }}</span>
            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="11">
              <span class="required">监测点名称</span>
              <span class="text">{{ detailsDataTop.stationName }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <span class="required">监测点类型</span>
              <span class="text">{{ detailsDataTop.type }}</span>
            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="11">
              <span class="required">巡检周期</span>
              <span class="text">{{ detailsDataTop.pollingPeriod }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <span class="required">经度</span>
              <span class="text">{{ detailsDataTop.longitude }}</span>
            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="11">
              <span class="required">纬度</span>
              <span class="text">{{ detailsDataTop.latitude }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <span class="required">地理位置</span>
              <span class="text">{{ detailsDataTop.address }}</span>
            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="11">
              <span class="required">高程（m）</span>
              <span class="text">{{ detailsDataTop.height }}</span>
            </el-col>
          </el-row>
        </div>
        <div class="bottom">
          <el-row v-for="(item, index) in detailsDataBottom" :key="index">
            <el-col :span="11">
              <span class="unrequired">{{ item[0].name }}</span>
              <span class="text">{{ item[0].content }}</span>
            </el-col>
            <el-col :span="2"> </el-col>
            <el-col :span="11">
              <span class="unrequired">{{ item[1].name }}</span>
              <span class="text">{{ item[1].content }}</span>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>

    <!-- 全景图模态框 -->
    <el-dialog
      class="panorama"
      :visible.sync="dialogVisible"
      :show-close="false"
      width="80%"
    >
      <!-- 自定义标题栏 -->
      <div slot="title" class="dialog-title">
        <span>{{ dialogTitle }}</span>
        <i class="el-icon-close" @click="dialogVisible = false"></i>
      </div>
      <div class="dialog-details" v-if="dialogTitle == '监测点全景图'">
        <div class="item">监测点编号：{{ baseList.pointNum }}</div>
        <br />
        <div class="item">监测点名称：{{ baseList.stationName }}</div>
        <br />
        <div class="item">监测点类型：{{ baseList.type }}</div>
        <br />
        <div class="item">监测点设备数：{{ baseList.deviceNum }}</div>
        <br />
        <div class="item">巡检周期：{{ baseList.pollingPeriod }}</div>
        <br />
        <div class="item">最近巡检时间：{{ baseList.lastPollingTime }}</div>
        <br />
        <div class="item">地理位置：{{ baseList.address }}</div>
        <br />
        <div class="item">经度：{{ baseList.longitude }}</div>
        <br />
        <div class="item">纬度：{{ baseList.latitude }}</div>
        <br />
        <div class="item">高程：{{ baseList.height }}</div>
      </div>
      <div class="dialog-details" v-if="dialogTitle == '设备全景图'">
        <div class="item">设备编号：{{ listObj.deviceNum }}</div>
        <br />
        <div class="item">监测类型：{{ listObj.type }}</div>
        <br />
        <div class="item">建设单位：{{ listObj.constructionUnit }}</div>
        <br />
        <div class="item">维护单位：{{ listObj.maintenanceUnit }}</div>
        <br />
        <div class="item">设备经度：{{ lng }}</div>
        <br />
        <div class="item">设备纬度：{{ lat }}</div>
        <br />
        <div class="item">备注：{{ listObj.remarks }}</div>
      </div>

      <iframe v-if="link" :src="link" frameborder="0" class="dialog-label"></iframe>
    </el-dialog>

    <!-- GIS模态框 -->
    <el-dialog
      class="panorama"
      :visible.sync="GISdialogVisible"
      :show-close="false"
      width="80%"
    >
      <!-- 自定义标题栏 -->
      <div slot="title" class="dialog-title">
        <span>{{ dialogTitle }}</span>
        <i class="el-icon-close" @click="GISdialogVisible = false"></i>
      </div>
      <iframe
        v-if="baseList.id === 1"
        :src="linkGIS"
        ref="iframes1"
        frameborder="0"
        class="dialog-label"
      ></iframe>
      <iframe
        v-if="baseList.id === 2"
        :src="linkGIS2"
        frameborder="0"
        class="dialog-label"
      ></iframe>
    </el-dialog>
  </div>
</template>

<script>
import AMap from "AMap";
import data from "./data.json";
export default {
  name: "DeviceMonitor",
  data() {
    return {
      map: null,
      markerBase: null,
      markerPoint: null,
      checkedMarker: null,
      checkedPointMarker: null,
      pointInfoWindow: null,
      parentId: 0,
      showBox: false,
      dialogVisible: false,
      GISdialogVisible: false,
      url: "",
      link: "",
      linkGIS: "",
      linkGIS2: "",
      showDetails: false,
      baseList: {},
      listObj: {},
      dialogTitle: "",
      showInfoWindow: false,
      scale: null,
      markerBaseAll: [],
      markerPointAll: [],
      detailsDataTop: {},
      detailsDataBottom: [],
      lng: null,
      lat: null,
      // vehicleMarker: null,
      vehicleMarker: [],
      vehicleInfoWindow: null,
      vehicleInfoWindowData: {},
      bankRoute: false,
      vehicleId: false,
      powerStateMarker: "",
      plateNumMarker: null,
      vehicleMarkerList: [],
      driving: null,
      drawOK: true,
      showVehicleData: [
        "LS4ASG2EXLG184330",
        "LS4ASG2EXKG172337",
        "LS4ASG2EXLG184117",
        "LS4ASG2E2LG116698",
        "LS4ASG2E3LG184329",
        "LS4ASG2E9LG184318",
      ], // 需要显示的杭州车辆车架号
      drivingRoutelM: null,
      routeLine: null,
      drivingRoutelVin: null,
      stationVehicleId: null,
    };
  },
  created() {
    this.initWebSocket();
  },
  mounted() {
    this.initMap();
    this.addMarkers();
    this.addPointMarkers();
    this.getVehicleLocation();
  },
  watch: {
    listObj(val) {
      // console.log(val);
      this.lng = val.location[0].toFixed(6);
      this.lat = val.location[1].toFixed(6);
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.path == "/VehicleInfo") {
      let path = from.path; //path为定义的变量，不是vue的data定义的变量，当前生命周期data还未初始化
      sessionStorage.setItem("pathUrl", path);
    }
    next();
  },
  methods: {
    // 跳转到巡检记录页面
    topollingRecord() {
      this.$router.push("PollingRecord");
    },
    // 监控地图缩放级别
    watchZoom() {
      this.map.on("zoomend", () => {
        if (this.map.getZoom() > 13) {
          this.map.remove(this.checkedMarker);
          this.map.remove(this.markerBaseAll);
          this.map.add(this.markerPointAll);
        } else {
          this.map.remove(this.checkedPointMarker);
          this.map.remove(this.markerPointAll);
          this.map.add(this.markerBaseAll);
          if (this.pointInfoWindow) {
            this.pointInfoWindow.close();
          }
          // 当显示监测点时，当前显示的监测点信息标记点显示选中状态
          if (this.showBox || this.showInfoWindow) {
            this.checkedMarker.setPosition(this.baseList.location);
            this.map.add(this.checkedMarker);
          }
        }
      });
    },
    // 关闭设备信息窗体
    closePointWindow() {
      console.log("close point window");
      this.showInfoWindow = false;
      this.pointInfoWindow.close();
    },
    // 关闭监测点信息窗口
    closeWindowBox() {
      this.showBox = false;
    },
    // 监测点详情模态框
    toDetails() {
      console.log("click to details");
      // 获取监测点详情数据【点击监测点时就获取数据】
      // this.detailsDataTop = data.details[0];
      this.showDetails = true;
    },
    showDialog(e) {
      if (!this.baseList.linkUrl) {
        this.$message.warning("无全景图数据");
      } else {
        this.dialogVisible = true;
        if (e.target.innerText == "全景照片") {
          this.dialogTitle = "监测点全景图";
          this.$nextTick(() => {
            this.link = this.baseList.linkUrl;
          });
        } else if (e.target.innerText == "全景图") {
          this.dialogTitle = "设备全景图";
          // this.$nextTick(() => {
          //   this.link = this.baseList.linkUrl;
          // });
        }
      }

      // 点击选中后的链接变色处理
      // this.isActive = e.target.innerHTML;
    },

    showGISDialog(e) {
      console.log("click show GIS-dialog", this.linkGIS);
      this.dialogTitle = e.target.innerText;
      this.GISdialogVisible = true;
      // document.getElementById('iframes').contentWindow.location.reload(true);

      this.$nextTick(() => {
        console.log(this.$refs.iframes1);
        if (this.baseList.id == 1) {
          this.linkGIS =
            "http://route.walkgis.club:28086/dzzh/#/?tab=龙门坎&x=-2761636.854534&y=4777215.292861&z=3189312.655414&pitch=-0.953803&heading=3.743699";
          this.linkGIS2 = "";
        } else if (this.baseList.id == 2) {
          this.linkGIS2 =
            "http://route.walkgis.club:28086/dzzh/#/?tab=东穆坞&x=-2763162.760979&y=4774388.803698&z=3192283.383429&pitch=-1.570796&heading=6.283185";
          this.linkGIS = "";
        }
      });
    },
    // // 车辆标记点
    // addVehicleMarkers() {
    //   // console.log("addVehicleMarkers", data.vehicleList);
    //   for (let i = 0; i < data.vehicleList.length; i++) {
    //     let vehicleImg =
    //       data.vehicleList[i].orderState == 1
    //         ? require("@/assets/images/monitor/car-offline.png")
    //         : require("@/assets/images/monitor/car-online.png");
    //     this.vehicleMarker = new AMap.Marker({
    //       anchor: "bottom-center",
    //       autoRotation: true, // 车辆行驶过程中，方向可变属性
    //       position: data.vehicleList[i].lnglat,
    //       offset: new AMap.Pixel(0, 5), // 设置点标记偏移量
    //     });
    //     this.vehicleMarker.setIcon(vehicleImg);
    //     this.map.add(this.vehicleMarker);
    //     this.vehicleMarker.moveAlong(data.vehicleList[i].directionLnglat, 50); //车辆行驶方向
    //     this.vehicleMarker.content = data.vehicleList[i];
    //     let content = this.$refs.vehicleInfowindow;
    //     // let content = `<div style="color:#fff">content</div>`;
    //     AMap.event.addListener(this.vehicleMarker, "click", (e) => {
    //       // console.log(e.target.content);
    //       this.vehicleId = true;
    //       this.map.setCenter(e.target.content.lnglat);
    //       this.vehicleInfoWindowData = data.vehicleList[i];
    //       this.vehicleInfoWindow = new AMap.InfoWindow({
    //         anchor: "bottom-center",
    //         isCustom: true,
    //         showShadow: true,
    //         closeWhenClickMap: true, // 控制是否在鼠标点击地图后关闭信息窗体，默认false，鼠标点击地图后不关闭信息窗体
    //         content: content,
    //         offset: new AMap.Pixel(130, 90),
    //       });
    //       this.$nextTick(() => {
    //         this.vehicleInfoWindow.open(this.map, e.target.content.lnglat);
    //         // console.log(this.vehicleInfoWindow.getContent());
    //       });
    //     });
    //   }
    // },
    //获取车辆定位信息
    async getVehicleLocation() {
      let _this = this;
      let { data: res } = await _this.$axios.get("/api/v3/maintain/monitor/vehicle");
      if (res.code == 1) {
        _this.vehicleLocal = res.data;
        _this.addVehicleMarker();
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //添加车辆标记
    addVehicleMarker() {
      let _this = this;
      let vinList = this.vehicleLocal;
      let data = [];
      this.showVehicleData.forEach((item) => {
        vinList.filter((v) => {
          // if (v.vin === "LS4ASG2EXLG184330") {
          //   console.log(v);
          // }
          if (v.vin == item) {
            data.push(v);
          }
        });
      });

      if (this.vehicleMarker.length > 0) {
        this.map.remove(this.vehicleMarker);
        this.vehicleMarkerList = [];
        this.vehicleMarker = [];
      }
      for (var i = 0; i < data.length; i++) {
        _this.varMarker = "";
        _this.powerStateMarker = "";
        _this.plateNumMarker = "";
        if (data[i].powerState == 1) {
          var powerContent =
            "<img style='width:14px;height:18px'  src='" +
            require("@/assets/images/monitor/icon-powering.png") +
            "'/>";
          _this.powerStateMarker = new AMap.Marker({
            zIndex: 200,
            content: powerContent,
            position: data[i].lnglat,
            offset: new AMap.Pixel(-30, -12),
            map: _this.map,
          });
        }
        if (data[i].vehicleState == 1) {
          let icon =
            data[i].version == 2
              ? require("@/assets/images/monitor/car-offline-2.png")
              : require("@/assets/images/monitor/car-offline.png");
          _this.varMarker = new AMap.Marker({
            position: data[i].lnglat,
            icon: icon,
            size: new AMap.Size(40, 24),
            map: _this.map,
            autoRotation: true, // 车辆行驶过程中，方向可变属性
            offset: new AMap.Pixel(-20, -12),
            clickable: true,
            zIndex: 100,
            angel: -90,
          });
          var plateNumContent =
            "<div style='position:relative'><img style='width:80px;height:27px'  src='" +
            require("@/assets/images/monitor/plateNum.png") +
            "'/><span style='position:absolute;color:#fff;font-size:12px;left:12px;top:3px'>" +
            data[i].plateNum +
            "</span></div>";
          _this.plateNumMarker = new AMap.Marker({
            zIndex: 100,
            content: plateNumContent,
            position: data[i].lnglat,
            offset: new AMap.Pixel(-40, -42),
            map: _this.map,
          });
        } else {
          let icon =
            data[i].version == 2
              ? require("@/assets/images/monitor/car-online-2.png")
              : require("@/assets/images/monitor/car-online.png");
          _this.varMarker = new AMap.Marker({
            position: data[i].lnglat,
            icon: icon,
            size: new AMap.Size(40, 24),
            map: _this.map,
            autoRotation: true, // 车辆行驶过程中，方向可变属性
            offset: new AMap.Pixel(-20, -12),
            zIndex: 120,
            clickable: true,
            angel: -90,
          });
          var plateContent =
            "<div style='position:relative'><img style='width:80px;height:27px'  src='" +
            require("@/assets/images/monitor/plateNum.png") +
            "'/><span style='position:absolute;color:#fff;font-size:12px;left:12px;top:3px'>" +
            data[i].plateNum +
            "</span></div>";
          _this.plateNumMarker = new AMap.Marker({
            zIndex: 120,
            content: plateContent,
            position: data[i].lnglat,
            offset: new AMap.Pixel(-40, -42),
            map: _this.map,
          });
          // 判断车辆方向
          _this.varMarker.moveAlong(data[i].directionLnglat, 50); //车辆行驶方向
        }
        _this.varMarker.content = data[i]; // 车辆信息窗体内容
        _this.vehicleMarker.push(_this.varMarker);
        // _this.vehicleMarker.push(_this.oilStateMarker)
        _this.vehicleMarker.push(_this.powerStateMarker);
        _this.vehicleMarker.push(_this.plateNumMarker);
        _this.vehicleMarkerList.push({
          vin: data[i].vin,
          lnglat: data[i].lnglat,
          vehicle: _this.varMarker,
          plateNum: _this.plateNumMarker,
          // oil: _this.oilStateMarker,
          power: _this.powerStateMarker,
        });
        AMap.event.addListener(_this.varMarker, "click", function (e) {
          _this.vin = e.target.content.vin;
          _this.deptId = e.target.content.deptId;
          _this.monitorLnglat = e.target.content.lnglat;
          _this.getVehicleInfowindow(_this.vin, _this.deptId);
        });
        AMap.event.addListener(_this.varMarker, "mouseover", function (e) {
          e.target.setTop(true);
        });
        AMap.event.addListener(_this.varMarker, "mouseout", function (e) {
          e.target.setTop(false);
        });
      }
      _this.$nextTick(() => {
        _this.map.add(_this.vehicleMarker);
        if (_this.locationError) {
          _this.map.setFitView();
        }
      });
    },

    // 点击查询车辆详情
    async getVehicleInfowindow(vin, deptId) {
      let _this = this;
      if (_this.routeLine) {
        _this.driving.clear();
        _this.map.remove(_this.routeLine);
        _this.routeLine = null;
      }
      let { data: res } = await _this.$axios.get(
        "/api/v3/maintain/monitor/vehicle/details?deptId=" + deptId + "&vin=" + vin
      );
      if (res.code == 1) {
        _this.vehicleInfoWindowData = {};
        _this.vehicleInfoWindowData = res.data;
        _this.stationVehicleId = _this.vehicleInfoWindowData.stationId;
        _this.vehicleId = true;
        _this.vehicleInfoWindow.show();
        _this.vehicleInfoWindow.setPosition(res.data.lnglat);
        _this.drivingRoutelVin = null;
        _this.bankRoute = false;
        if (res.data.destLnglat && res.data.destLnglat.length > 0) {
          // 如果车辆有目的地
          _this.drivingRoutelVin = _this.vehicleInfoWindowData.vin;
          _this.drawRouteLine(res.data.lnglat, res.data.destLnglat, "#00E46B");
        }
        sessionStorage.setItem("lnglat", res.data.lnglat);
        _this.vehicleInfoSwitch = !_this.vehicleInfoSwitch;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 根据起始点画路线
    drawRouteLine(start, end, color) {
      let _this = this;
      if (_this.routeLine || !_this.drawOK) {
        _this.driving.clear();
        _this.map.remove(_this.routeLine);
        _this.routeLine = null;
        _this.drivingRoutelVin = null;
        _this.drawOK = true;
      }
      _this.drivingRoutel = "";
      _this.drivingTime = "";
      if (start.length > 0 && _this.drawOK) {
        _this.drawOK = false;
        // 根据起终点经纬度规划驾车导航路线
        _this.driving.search(
          new AMap.LngLat(start[0], start[1]),
          new AMap.LngLat(end[0], end[1]),
          (status, result) => {
            var path = [];
            for (var i = 0, l = result.routes[0].steps.length; i < l; i++) {
              var step = result.routes[0].steps[i];
              for (var j = 0, n = step.path.length; j < n; j++) {
                path.push(step.path[j]);
              }
            }
            _this.drivingRoutel = result.routes[0].distance / 1000 + "公里";
            let hours = Math.floor(result.routes[0].time / 3600);
            let mintinus = Math.floor(result.routes[0].time / 60 - hours * 60);
            _this.drivingTime = hours + "小时" + mintinus + "分钟";
            _this.bankRoute = true;
            _this.routeLine = new AMap.Polyline({
              map: _this.map,
              path: path,
              isOutline: false,
              strokeWeight: 4,
              strokeColor: color,
              lineJoin: "round",
            });
            _this.drawOK = true;
          }
        );
      }
    },

    // 点击跳转车辆详情
    getVehicleDetail(vin) {
      if (!vin) {
        this.$message.warning("车架号为空，无法查看车辆详情");
      } else {
        this.$router.push({
          name: "VehicleInfo",
          params: {
            vin: vin,
            active: "real",
          },
        });
        this.$store.state.MenuStore.menu_path = "车辆管理 > 车辆管理";
      }
    },

    // 设备点
    addPointMarkers() {
      this.markerImage = [];
      for (let i = 0; i < data.pointMarkers.length; i++) {
        this.markerImage.push(data.pointMarkers[i].markerImage);
        var myIcon = new AMap.Icon({
          size: new AMap.Size(26, 32),
          image: require("@/assets/images/geological/" + this.markerImage[i]),
          // image: require("@/assets/images/monitor/rain-gauge.png"),
          imageSize: new AMap.Size(26, 32),
          // 图标取图偏移量
        });
        this.markerPoint = new AMap.Marker({
          icon: myIcon,
          anchor: "bottom-center",
          position: data.pointMarkers[i].location,
          offset: new AMap.Pixel(0, 5), // 设置点标记偏移量
        });
        // 保存具体监测点信息
        this.markerPoint.content = data.pointMarkers[i];
        // 给每个具体的监测点绑定监听点击事件
        AMap.event.addListener(this.markerPoint, "click", (e) => {
          // console.log(e.target.content);
          this.link = data.pointMarkers[i].linkUrl;
          // 判断该设备点的所属监测点
          this.parentId = e.target.content.pid;
          data.list.forEach((p) => {
            if (p.id == this.parentId) {
              this.baseList = p;
            }
          });
          this.$nextTick(() => {
            this.url = require("@/assets/images/geological/" + this.baseList.imgUrl);
          });
          this.showBox = true;
          this.listObj = e.target.content;
          this.detailsDataTop = this.baseList.details;
          this.detailsDataBottom = this.baseList.details.title;
          // 点击显示标记点选中状态
          this.checkedPointMarker.setPosition(e.target.content.location);
          this.map.add(this.checkedPointMarker);
          this.pointInfoWindow = new AMap.InfoWindow({
            anchor: "bottom-center",
            isCustom: true,
            showShadow: true,
            closeWhenClickMap: true, // 控制是否在鼠标点击地图后关闭信息窗体，默认false，鼠标点击地图后不关闭信息窗体
            content: this.$refs.pointInfoWindow,
            offset: new AMap.Pixel(0, -30),
            retainWhenClose: true,
          });
          this.showInfoWindow = true;
          this.pointInfoWindow.open(this.map, e.target.content.location);
        });
        this.markerPointAll.push(this.markerPoint);
        // 监控地图缩放级别
        this.watchZoom();
      }
    },
    // 监测点
    addMarkers() {
      let mkIcon = new AMap.Icon({
        size: new AMap.Size(26, 38),
        image: require("@/assets/images/geological/monitorStation.png"),
        imageSize: new AMap.Size(26, 38), // 图标取图偏移量
      });
      for (let i = 0; i < data.list.length; i++) {
        this.markerBase = new AMap.Marker({
          icon: mkIcon,
          anchor: "bottom-center",
          position: data.list[i].location,
          offset: new AMap.Pixel(0, 5), // 设置点标记偏移量
        });
        // 将车辆信息添加到事件回调参数中【添加到事件回调参数的content属性上】
        this.markerBase.content = data.list[i];
        // 监听点击标记点事件
        AMap.event.addListener(this.markerBase, "click", (e) => {
          // console.log(e.target.content);
          // if (e.target.content.id == 1) {
          //   this.linkGIS = "http://route.walkgis.club:28086/dzzh/#/?tab=龙门坎";
          //   // this.linkGIS2 = "";
          // } else if (e.target.content.id == 2) {
          //   this.linkGIS = "http://route.walkgis.club:28086/dzzh/#/?tab=东穆坞";
          //   // this.linkGIS = "";
          // }
          this.url = require("@/assets/images/geological/" + e.target.content.imgUrl);
          // 点击显示标记点选中状态
          this.checkedMarker.setPosition(e.target.content.location);
          this.map.add(this.checkedMarker);
          // 通过传递该点击的标记点参数数据得到该车辆的详细信息
          this.baseList = e.target.content;
          this.detailsDataTop = e.target.content.details;
          this.detailsDataBottom = e.target.content.details.title;
          // 显示信息窗体
          this.showBox = true;
          // this.map.setFitView();
          this.map.setCenter(e.target.content.location);
        });
        // AMap.event.addListener(this.map, "click", () => {
        //   if (this.showBox) {
        //     this.showBox = false;
        //   }
        // });
        this.markerBaseAll.push(this.markerBase);
        this.map.add(this.markerBaseAll);
        // 监控地图缩放级别
        this.watchZoom();
      }
    },
    initMap() {
      this.map = new AMap.Map("map-box", {
        resizeEnable: true,
        zoom: 12,
        zooms: [3, 20],
        expandZoomRange: true,
        mapStyle: "amap://styles/grey",
      });
      AMap.plugin("AMap.Geolocation", () => {
        var geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, //是否使用高精度定位，默认:true
          showButton: false,
          showMarker: false,
        });
        this.map.addControl(geolocation);
        // 判断地图中心点
        this.map.setCenter(data.markers[1].location);
      });
      // scale 比例尺
      AMap.plugin(["AMap.Scale"], () => {
        this.scale = new AMap.Scale({
          visible: true,
        });
        this.map.addControl(this.scale);
      });
      // 创建点击具体监测点时图标下选中状态
      let mkIcon = new AMap.Icon({
        size: new AMap.Size(50, 21),
        image: require("@/assets/images/checked.gif"),
        imageSize: new AMap.Size(50, 21), // 图标取图偏移量
      });
      this.checkedMarker = new AMap.Marker({
        icon: mkIcon,
        zIndex: 90,
        offset: new AMap.Pixel(-25, -2),
      });
      this.checkedPointMarker = new AMap.Marker({
        icon: mkIcon,
        zIndex: 90,
        offset: new AMap.Pixel(-25, -2),
      });
      // 车辆信息窗体
      this.vehicleInfoWindow = new AMap.Marker({
        map: this.map,
        content: this.$refs.vehicleInfowindow.$el,
        zIndex: 300,
        offset: new AMap.Pixel(30, -40),
      });
      // 初始化地图路线查询插件
      AMap.plugin("AMap.Driving", () => {
        this.driving = new AMap.Driving({
          policy: AMap.DrivingPolicy.LEAST_FEE,
          hideMarkers: true,
          isOutline: false,
          autoFitView: true,
        });
      });
      // 点击地图，清除路线规划和车辆信息窗体
      AMap.event.addListener(this.map, "click", () => {
        if (this.routeLine) {
          this.driving.clear();
          this.map.remove(this.routeLine);
          this.routeLine = null;
          this.drivingRoutelVin = null;
        }
        this.vehicleInfoWindow.hide();
      });
    },

    initWebSocket() {
      // 初始化websocket
      // ws地址
      const sessionId = window.sessionStorage.getItem("sessionId");
      // const wsuri = process.env.WS_API + `?user-number=${userNumber}`
      // const wsuri = `ws://192.168.90.152:8070/monitor;JSESSIONID=${sessionId}`; //测试环境websocket地址
      const wsuri = `ws://116.63.189.185:9070/monitor;JSESSIONID=${sessionId}`; //运营环境websocket地址
      this.websock = new WebSocket(wsuri);
      // 监听socket打开
      this.websock.onopen = function () {
        console.log("浏览器WebSocket已打开");
      };
      this.websock.onmessage = this.websocketonmessage; // 监听socket消息接收
      this.websock.onclose = this.websocketclose; // 监听socket关闭
      console.log(this.vehicleMarkerList);
    },
    //  监听socket数据接收
    websocketonmessage(e) {
      const redata = JSON.parse(e.data);
      if (!redata || redata == 1) {
        return;
      } else {
        console.log(redata);
        // 车辆jps移动
        if (redata.type == 10) {
          let _this = this;
          console.log(_this.vehicleMarkerList);
          _this.vehicleMarkerList.map((item) => {
            //找到对应车辆
            if (item.vin == redata.data.vin) {
              _this.drivingRoutelM = null;
              _this.driving.search(
                new AMap.LngLat(item.lnglat[0], item.lnglat[1]),
                new AMap.LngLat(redata.data.lnglat[0], redata.data.lnglat[1]),
                (status, result) => {
                  var path = [];
                  for (var i = 0, l = result.routes[0].steps.length; i < l; i++) {
                    var step = result.routes[0].steps[i];
                    for (var j = 0, n = step.path.length; j < n; j++) {
                      path.push(step.path[j]);
                    }
                  }
                  _this.drivingRoutelM = result.routes[0].distance;
                  if (redata.data.absVehicleSpeed > 10 && _this.drivingRoutelM > 50) {
                    // 车辆图标
                    item.vehicle.moveTo(
                      redata.data.lnglat,
                      redata.data.absVehicleSpeed * 50,
                      (val) => {
                        return val;
                      }
                    );
                    // 车牌号
                    item.plateNum.moveTo(
                      redata.data.lnglat,
                      redata.data.absVehicleSpeed * 50,
                      (val) => {
                        return val;
                      }
                    );
                    if (item.vin == _this.vin) {
                      //当前车辆信息窗体被打开
                      _this.vehicleInfoWindow.moveTo(
                        redata.data.lnglat,
                        redata.data.absVehicleSpeed * 50,
                        (val) => {
                          return val;
                        }
                      );
                    }
                    // 车辆发电
                    if (item.power) {
                      item.power.moveTo(
                        redata.data.lnglat,
                        redata.data.absVehicleSpeed * 50,
                        (val) => {
                          return val;
                        }
                      );
                    }
                  } else if (
                    redata.data.absVehicleSpeed > 10 &&
                    50 > _this.drivingRoutelM
                  ) {
                    // 车辆图标
                    item.vehicle.moveTo(
                      redata.data.lnglat,
                      redata.data.absVehicleSpeed * 20,
                      (val) => {
                        return val;
                      }
                    );
                    // 车牌号
                    item.plateNum.moveTo(
                      redata.data.lnglat,
                      redata.data.absVehicleSpeed * 20,
                      (val) => {
                        return val;
                      }
                    );
                    if (item.vin == _this.vin) {
                      //当前车辆信息窗体被打开
                      _this.vehicleInfoWindow.moveTo(
                        redata.data.lnglat,
                        redata.data.absVehicleSpeed * 20,
                        (val) => {
                          return val;
                        }
                      );
                    }
                    // 车辆发电
                    if (item.power) {
                      item.power.moveTo(
                        redata.data.lnglat,
                        redata.data.absVehicleSpeed * 20,
                        (val) => {
                          return val;
                        }
                      );
                    }
                  } else if (
                    redata.data.absVehicleSpeed <= 100 &&
                    _this.drivingRoutelM > 0
                  ) {
                    item.vehicle.setPosition(redata.data.lnglat);
                    item.plateNum.setPosition(redata.data.lnglat);
                    if (item.power) {
                      item.power.setPosition(redata.data.lnglat);
                    }
                    if (item.oil) {
                      item.oil.setPosition(redata.data.lnglat);
                    }
                    if (item.vin == _this.vin) {
                      _this.vehicleInfoWindow.setPosition(redata.data.lnglat);
                    }
                  }
                  item.lnglat = redata.data.lnglat;
                }
              );
              // ------------是否能解决mac系统地图闪烁问题end-------
              if (item.vin == _this.drivingRoutelVin) {
                //当前车辆路线被查看
                if (_this.routeLine) {
                  _this.driving.clear();
                  _this.map.remove(_this.routeLine);
                  _this.routeLine = null;
                }
                if (redata.data.destLnglat && redata.data.destLnglat.length > 0) {
                  //车辆自己有目的地
                  _this.drawRouteLine(
                    redata.data.lnglat,
                    redata.data.destLnglat,
                    "#00E46B"
                  );
                }
              }
            }
          });
        }
        // 车辆详情
        if (redata.type == 12) {
          if (this.vin == redata.data.vin) {
            // 当前打开的信息窗体
            this.vehicleInfoWindowData = redata.data;
            this.stationVehicleId = this.vehicleInfoWindowData.stationId;
          }
        }
        // 车辆在线离线状态
        if (redata.type == 15) {
          this.vehicleMarkerList.map((item) => {
            if (redata.data.vin == item.vin) {
              if (redata.data.status == 1) {
                let icon =
                  redata.data.version == 2
                    ? require("@/assets/images/monitor/car-online-2.png")
                    : require("@/assets/images/monitor/car-online.png");
                //在线
                item.vehicle.setIcon(icon);
                item.vehicle.setzIndex(120);
              } else {
                let icon =
                  redata.data.version == 2
                    ? require("@/assets/images/monitor/car-offline-2.png")
                    : require("@/assets/images/monitor/car-offline.png");
                //离线
                item.vehicle.setIcon(icon);
                item.vehicle.setzIndex(100);
              }
            }
          });
        }
        // 车辆发电状态
        // if (redata.type == 16) {
        //   this.vehicleMarkerList.map((item) => {
        //     if (redata.data.vin == item.vin) {
        //       if (redata.data.status == 1) {
        //         //发电
        //         var powerContent =
        //           "<img style='width:14px;height:18px'  src='" +
        //           require("@/assets/images/monitor/icon-powering.png") +
        //           "'/>";
        //         this.powerStateMarker = new AMap.Marker({
        //           zIndex: 200,
        //           content: powerContent,
        //           position: item.lnglat,
        //           offset: new AMap.Pixel(-30, -12),
        //           map: this.map,
        //         });
        //         this.map.add(this.powerStateMarker);
        //         item.power = this.powerStateMarker;
        //       } else {
        //         //停止发电
        //         if (item.power) {
        //           this.map.remove(item.power);
        //           item.power = "";
        //         }
        //       }
        //     }
        //   });
        // }
      }
    },
    //  监听socket关闭
    websocketclose() {
      // console.log(e);
      // this.websock.close()
      // this.$notify({
      //   title: '错误',
      //   message: 'websocket已关闭，无法接收实时报警信息,请联系汪汪',
      //   type: 'error',
      //   duration: 5000
      // })
    },
  },
};
</script>

<style lang="scss" scoped>
$font-name: "Arial Negreta", "Arial";
.deviceMonitor-container {
  position: relative;
  // min-width: 1650px;
  height: 100%;
  #map-box {
    width: 100%;
    height: calc(100vh - 60px);
    min-height: 876px;
  }
  .watch-header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 100%;
    max-width: 1660px;
    height: 75px;
    background: url("../../../assets/images/monitor/watch-header.png") no-repeat;
    background-size: 100% auto;
    z-index: 999;
    .header-title {
      width: 100%;
      text-align: center;
      font-size: 40px;
      font-family: $font-name;
      font-weight: bold;
      color: #00c9f0;
      letter-spacing: 4px;
    }
  }
  .details {
    .details-content {
      .top {
        .el-row {
          display: flex;
          align-items: center;
          height: 32px;
          .required {
            color: #333;
            display: inline-block;
            width: 108px;
          }
          .required::after {
            content: "*";
            color: #ff0000;
            margin-right: 4px;
            margin-top: 6px;
          }
          .text {
            display: inline-block;
            color: #666;
          }
        }
      }
      .bottom {
        margin: 40px 0;
        .el-row {
          height: 38px;
          box-sizing: border-box;
          margin-bottom: 10px !important;
          .el-col {
            display: flex;
            height: 38px;
            .unrequired {
              display: inline-block;
              color: #333;
              width: 110px;
            }
            .text {
              display: inline-block;
              color: #666;
            }
          }
        }
      }
    }
  }
  .pointInfoWindow {
    width: 300px;
    font-size: 14px;
    color: #333;
    background: #fff;
    opacity: 0.9;
    border-radius: 4px;
    .pointInfo-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 24px;
      font-weight: 600;
      padding: 0 10px;
      background: #f2f2f2;
    }
    .pointInfo-content {
      padding: 10px;
      .el-row {
        height: 20px;
        line-height: 20px;
      }
    }
    .pointInfo-footer {
      padding: 10px;
      border-top: 1px solid #ccc;
    }
    // 三角形
    .delta {
      position: absolute;
      left: calc(50% - 8px);
      bottom: 0;
      width: 0;
      height: 0;
      border-top: 10px solid #fff;
      border-right: 8px solid transparent;
      border-left: 8px solid transparent;
    }
  }
  .infoWindow {
    position: relative;
    padding: 10px;
    background: rgba(255, 255, 255, 0.8);
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 20px;
    width: 185px;
    border-radius: 4px;
    box-sizing: border-box;
    .orderTime {
      position: absolute;
      width: 185px;
      line-height: 20px;
      background: rgba(255, 255, 255, 0.8);
      top: -22px;
      left: 0;
      border-radius: 3px;
      padding-left: 10px;
    }
    .infoWindow-detail {
      .carNumber {
        color: #0060ff;
      }
      .vehicleStatus {
        span {
          display: inline-block;
          text-align: center;
          width: 54px;
          height: 20px;
          border-radius: 10px;
          margin-right: 5px;
          color: rgba(255, 255, 255, 0.8);
        }
        .powering {
          background: #00beda;
        }
        .fueling {
          background: #ffa200;
        }
        .routing {
          background: #00cb4c;
        }
        .no-receive {
          background: #888888;
        }
        .no-order {
          background: #0078ff;
        }
      }
    }
    // 三角形
    .delta {
      position: absolute;
      left: -10px;
      top: 30px;
      width: 0;
      height: 0;
      border-top: 8px solid transparent;
      border-right: 10px solid rgba(255, 255, 255, 0.8);
      border-bottom: 8px solid transparent;
    }
    // 查看详情
    .checkDetail {
      position: absolute;
      right: -30px;
      top: 0;
      width: 20px;
      height: 82px;
      background: rgba(0, 148, 255, 0.8);
      border-radius: 0px 3px 3px 0px;
      color: #fff;
      text-align: center;
      padding: 5px;
      cursor: pointer;
    }
  }

  .windowBox {
    width: 350px;
    min-height: 770px;
    background: url("../../../assets/images/monitor/left_rightBox.png") no-repeat;
    background-size: 350px 770px;
    object-fit: contain;
    position: absolute;
    top: 80px;
    right: 20px;
    font-size: 12px;
    padding: 20px 10px;
    box-sizing: border-box;
    z-index: 999;
    .point-title {
      width: calc(100% - 10px);
      height: 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px;
      font-weight: 600;
      span {
        color: #97abea;
        font-size: 14px;
        padding-bottom: 16px;
      }
    }
    .point-content {
      color: #fff;
      padding: 0 10px;
      .text {
        padding: 10px 10px 15px;
        color: #ccc;
        .el-row {
          padding-bottom: 10px;
        }
      }

      .tag {
        display: flex;
        justify-content: center;
        box-sizing: border-box;
        padding: 0 10px;
        font-size: 13px;
      }
    }
  }
  ::v-deep .amap-scale-text {
    color: #fff;
  }
  .el-icon-close {
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    color: #333;
    &.cive {
      cursor: pointer;
      width: 18px;
      height: 18px;
      line-height: 18px;
      text-align: center;
      font-weight: 600;
      color: #fff;
      background: #0094ff;
      border-radius: 50%;
      margin-bottom: 20px;
    }
  }

  .dialog-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 600;
    padding-right: 20px;
  }
  .dialog-label {
    display: block;
    width: 100%;
    height: 84vh;
  }
  ::v-deep .details .el-dialog {
    min-width: 1076px;
  }
  ::v-deep .panorama .el-dialog {
    position: relative;
    margin-top: 5vh !important;
    .el-dialog__body {
      padding: 0;
    }
    .dialog-details {
      position: absolute;
      top: 100px;
      left: 10px;
      height: 60%;
      font-size: 14px;
      color: #333;
      .item {
        display: inline-block;
        background: #ccc;
        opacity: 0.8;
        margin-bottom: 6px !important;
      }
    }
  }
}
</style>
